import PropTypes from 'prop-types';
var propTypes = {
  customStyle: PropTypes.any,
  disabled: PropTypes.bool,
  icon: PropTypes.element
};
export default propTypes;